import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const LongArrowRight16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M10.5027 5.70737C10.2432 5.45938 10.2338 5.04793 10.4818 4.78837C10.7298 4.52881 11.1412 4.51944 11.4008 4.76744L15.3414 8.53249C15.4697 8.65513 15.5424 8.82493 15.5424 9.00246C15.5424 9.00941 15.5422 9.01635 15.542 9.02328C15.5422 9.03026 15.5424 9.03726 15.5424 9.04429C15.5424 9.30061 15.394 9.52227 15.1785 9.6281L11.4008 13.2375C11.1412 13.4855 10.7298 13.4761 10.4818 13.2166C10.2338 12.957 10.2432 12.5455 10.5027 12.2976L13.2274 9.69429H2.10592C1.74693 9.69429 1.45592 9.40327 1.45592 9.04429C1.45592 8.6853 1.74693 8.39429 2.10592 8.39429H13.3149L10.5027 5.70737Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
